import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import type { Outshipment, CreateOutshipmentInput, UpdateOutshipmentInput } from '@aigftpwatch/shared';

export function useOutshipments(status?: string, page = 1) {
  const params = new URLSearchParams({ page: String(page) });
  if (status) params.set('status', status);
  return useQuery({
    queryKey: ['outshipments', status, page],
    queryFn: () => api.getPaginated<Outshipment>(`/outshipments?${params}`),
  });
}

export function useOutshipment(id: number) {
  return useQuery({
    queryKey: ['outshipments', id],
    queryFn: () => api.get<Outshipment>(`/outshipments/${id}`).then((r) => r.data),
    enabled: !!id,
  });
}

export function useCreateOutshipment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateOutshipmentInput) => api.post<Outshipment>('/outshipments', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['outshipments'] }),
  });
}

export function useUpdateOutshipment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: UpdateOutshipmentInput & { id: number }) =>
      api.put<Outshipment>(`/outshipments/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['outshipments'] }),
  });
}

export function useSubmitOutshipment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post(`/outshipments/${id}/submit`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['outshipments'] }),
  });
}
